<template>
	<div>
		<div class="columns is-multiline">
			<div class="column is-3">
				<b-field label="Type">
					<b-select v-model="divider.type" expanded>
						<option value="RECTANGLE">Square/Rectangle</option>
						<option value="CIRCLE">Circle</option>
					</b-select>
				</b-field>
			</div>
			<div class="column is-3">
				<b-field label="Width">
					<b-numberinput :controls="false" v-model="divider.width"></b-numberinput>
				</b-field>
			</div>
			<div v-if="divider.type == 'RECTANGLE'" class="column is-3">
				<b-field label="Height">
					<b-numberinput :controls="false" v-model="divider.height"></b-numberinput>
				</b-field>
			</div>
			<div v-if="divider.type == 'RECTANGLE'" class="column is-3">
				<b-field label="No. Points (X-Axis)">
					<b-numberinput :controls="false" v-model="divider.polygon.no_points_x_axis"></b-numberinput>
				</b-field>
			</div>
			<div v-if="divider.type == 'RECTANGLE'" class="column is-3">
				<b-field label="No. Points (Y-Axis)">
					<b-numberinput :controls="false" v-model="divider.polygon.no_points_y_axis"></b-numberinput>
				</b-field>
			</div>
			<div v-if="divider.type == 'CIRCLE'" class="column is-3">
				<b-field label="No. of Points">
					<b-numberinput :controls="false" v-model="divider.circle.no_points"></b-numberinput>
				</b-field>
			</div>
			<div v-if="divider.type == 'CIRCLE'" class="column is-3">
				<b-field label="Start Angle">
					<b-numberinput :controls="false" v-model="divider.circle.start_angle"></b-numberinput>
				</b-field>
			</div>
			<div class="column is-3">
				<b-field label="Bg Color">
					<b-input v-model="divider.bg_color"></b-input>
				</b-field>
			</div>
			<div class="column is-3">
				<b-field label="Stroke Color">
					<b-input v-model="divider.stroke_color"></b-input>
				</b-field>
			</div>
			<div class="column is-3">
				<b-field label="Answer">
					<b-select v-model="divider.answer" expanded>
						<option value="1/4">Quarter</option>
						<option value="1/3">One-Third</option>
						<option value="1/2">Half</option>
					</b-select>
				</b-field>
			</div>

			<div class="column is-12">
				<show-divider :divider="divider"></show-divider>
			</div>
		</div>
	</div>
</template>
<script>
import ShowDivider from '@/components/Question/ShowDivider';
export default {
	name : 'set-divider',
	components : {
		ShowDivider
	},
	props : {
		value : {
			type : Object
		}
	},
	data(){
		return {
			divider : this.value
		}
	},
	watch : {
		value : {
			handler : function(new_val){
				this.divider = new_val
			},
			deep : true
		},
		divider : {
			handler : function(new_val){
				this.$emit('input', new_val)
			},
			deep : true
		}
	}
}
</script>
